(function(){
    "use strict";

    /**
     * process selector input
     */
    window.addEventListener('message', function(e) {
        if (!e.data) return;

        let dataStr = e.data;

        if (typeof dataStr !== 'string') {
            return;
        }
        if (dataStr.startsWith('eventgalleryGooglePhotosAlbum_')) {
            var data = JSON.parse(dataStr.replace('eventgalleryGooglePhotosAlbum_',''));

            let albumField = document.getElementById('foldertype-4-album')
            albumField.value = data.albumid;

            let titleField = document.getElementById('foldertype-4-title');
            titleField.value = data.title;

            albumField.onchange();

            //Joomla 4 button
            let closeBtn = document.querySelector('#google-photos-album-selector-modal .modal-header button.btn-close');
            if (!closeBtn) {
                // Joomla 3 button
                closeBtn = document.querySelector('#google-photos-album-selector-modal .modal-header button.close');
            }
            closeBtn.click();
        }
    });

    document.addEventListener('DOMContentLoaded', () =>{

        let button = document.querySelector('.google-photos-api-oauth-trigger-button');
        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                let id = e.target.getAttribute('data-id');

                let oauthWindow = window.open("index.php?option=com_eventgallery&view=googlephotos&layout=getauthtoken&tmpl=component&id=" + id, "_blank", "width=700,height=550");
                if (!oauthWindow || oauthWindow.closed || typeof oauthWindow.closed === 'undefined') {
                    alert('Failed');
                }
            });
        }

    });

})();
